// Shared design tokens. Keeps the dashboard/admin surfaces visually
// consistent without introducing a new styling framework.
const theme = {
  colors: {
    primary: "#4B9FE1",
    primaryDark: "#0F2557",
    primarySoft: "#EAF3FC",
    accent: "#6fa55f",
    background: "#F5F7FA",
    surface: "#FFFFFF",
    border: "#E4E9F0",
    text: "#101828",
    textMuted: "#5B6472",
    danger: "#FF5578",
    success: "#2E9E5B",
  },
  radius: {
    sm: "6px",
    md: "10px",
    lg: "16px",
  },
  shadow: {
    card: "0 1px 3px rgba(16, 24, 40, 0.08), 0 1px 2px rgba(16, 24, 40, 0.06)",
    raised: "0 4px 12px rgba(16, 24, 40, 0.10)",
  },
}

export default theme
